<ng-template #content_batch_entry let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.purchase_entry">
        <div class="side_popup_header">
            <span>{{localService.languageContent.purchase_entry.batch_header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;"
        [ngStyle]="{'height' : (localService.sideBarBodyHeight - 50) + 'px'}" *ngIf="batchEntryInitialization">
        <div class="row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.purchase_entry.batch_id" />
                <input autocomplete="off" type="text" id="{{elementIds.title}}" class="en"
                    [(ngModel)]="batchEntryInitialization.batchEntry.v2"
                    placeholder="{{localService.languageContent.purchase_entry.batch_id}}"
                    title="{{localService.languageContent.purchase_entry.batch_id}}" />
            </div>
        </div>
        <div class="row" style="margin-top: 25px;">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.purchase_entry.valid_to" />
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                &nbsp;
            </div>
            <div class="col-10">
                <label style="font-weight: normal;margin-left: 15px;">
                    <input type="checkbox" [(ngModel)]="isNoValidity" (change)="onAction(1)" />
                    <span class="normal_color">{{localService.languageContent.purchase_entry.no_validity}}</span>
                </label>
            </div>
        </div>
        <div class="row" *ngIf="!isNoValidity">
            <div class="col-2">
                &nbsp;
            </div>
            <div class="col-10">
                <app-date-picker [selectedDate]="batchEntryInitialization.batchEntry.v3" [isShowClearButton]="true" [isLoadTodayDate]="false"
                    (selectedDateChange)="batchEntryInitialization.batchEntry.v3 = $event;" />
            </div>
        </div>
        <div class="row" *ngIf="!isNoValidity">
            <div class="col-2">
                &nbsp;
            </div>
            <div class="col-10">
                <label style="font-weight: normal;margin-left: 15px;">
                    <input type="checkbox" [(ngModel)]="isAutoDeactive" (change)="onAction(1)" />
                    <span class="normal_color">{{localService.languageContent.purchase_entry.is_auto_deactive}}</span>
                </label>
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-8" style="text-align: left;">
                <span *ngIf="message != ''"
                    [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
            </div>
            <div class="col-4" style="text-align: right;">
                <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onAction(2)">
                    {{id ? localService.languageContent.common.update :
                    localService.languageContent.common.create}}
                </button>
            </div>
        </div>
    </div>
</ng-template>